import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import App from '@/App'
import theme from './config/theme'
import { UserProvider } from '@/components/providers/user-provider'
import { CustomerProvider } from '@/components/providers/customer-provider'
import { Provider } from 'react-redux'
import { store, persistor  } from './store/store'
import { PersistGate } from 'redux-persist/integration/react'
import Auth0ProviderWithNavigate from './components/Auth0ProviderWithNavigate'
import ErrorBoundary from './components/ErrorBoundary'
import { BrowserRouter } from 'react-router-dom'
import './styles/global.scss'
import MiniLoader from '@/components/MiniLoader'
// import { SiteProvider } from './components/providers/site-provider'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n';
import { I18nSyncProvider } from './components/providers/i18n-provider'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient()

const root = (
  <Provider store={store}>
    <PersistGate loading={<MiniLoader size={24} />} persistor={persistor}>
      <BrowserRouter>
        <Auth0ProviderWithNavigate>
          <UserProvider>
            <CustomerProvider>
              <QueryClientProvider client={queryClient}>
              <ThemeProvider theme={theme}>
              <CssBaseline />
              <ErrorBoundary>
                  <div className="topheader">
                      <emr-corporate-header search={false} langselector={false} loginicon={false} className="emerson-header"></emr-corporate-header>
                  </div>
                  <I18nextProvider i18n={i18n}>
                    <I18nSyncProvider>
                      <App />
                    </I18nSyncProvider>
                  </I18nextProvider>
                  <emr-legal-footer className="fixed-footer" />
              </ErrorBoundary>
              </ThemeProvider>
              </QueryClientProvider>
            </CustomerProvider>
          </UserProvider>
        </Auth0ProviderWithNavigate>
      </BrowserRouter>
    </PersistGate>
  </Provider>
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  import.meta.env.DEV ? <React.StrictMode>{root}</React.StrictMode> : root
)
